/// <reference no-default-lib="true" />
/// <reference lib="esnext" />
/// <reference lib="dom" />

export function initLabelToggles() {
  const labelToggles = Array.from(document.querySelectorAll('.label__toggle'))

  for (const labelToggle of labelToggles) {
    if (!(labelToggle instanceof HTMLElement)) {
      continue
    }
    if (labelToggle.dataset.hydrated) continue
    labelToggle.dataset.hydrated = 'true'

    labelToggle.addEventListener('toggle', () => {
      const current = labelToggle.getAttribute('data-label-toggle') || 'default'

      if (current === 'default') {
        labelToggle.setAttribute('data-label-toggle', 'toggle')
      } else {
        labelToggle.setAttribute('data-label-toggle', 'default')
      }
    })

    labelToggle.addEventListener('toggle-default', () => {
      labelToggle.setAttribute('data-label-toggle', 'default')
    })

    labelToggle.addEventListener('toggle-toggle', () => {
      labelToggle.setAttribute('data-label-toggle', 'toggle')
    })
  }
}
